import { api } from '@/core/api/';
import academicYearService from '@/modules/common/academicyear.api';

const apiUrl = 'api/providerregistryvisit';
export default {
  async getAcademicYears() {
    return academicYearService.getRegistryVisit();
  },
  async getMonths(academicYear) {
    return await api.get(`${apiUrl}/summarymonths/${academicYear}`);
  },
  async getCenters(academicYearId, month) {
    return await api.get(`${apiUrl}/summarycenters/${academicYearId}/${month}`);
  },
  async getServices(academicYearId, month, centerId, companyId) {
    return await api.get(
      `${apiUrl}/summaryservices/${academicYearId}/${month}/${centerId}/${companyId}`
    );
  },
  async getSpecialists(academicYearId, month, companyId, centerId, serviceId) {
    return await api.get(
      `${apiUrl}/summaryspecialits/${academicYearId}/${month}/${companyId}/${centerId}/${serviceId}`
    );
  },
  async getStudentSummary(
    academicYearId,
    companyId,
    month,
    centerId,
    disciplineTypeId,
    specialistId,
    statusId,
    therapyDocumentTypeId,
    specialistsOrCompaniesId,
    locationServiceId
  ) {
    return await api.get(
      `${apiUrl}/studentsummary/${academicYearId}/${companyId}/${month}/${centerId}/${disciplineTypeId}/${specialistId}/${statusId}/${therapyDocumentTypeId}/${specialistsOrCompaniesId}/${locationServiceId}`
    );
  },
  async uploadFiles(data) {
    return api.post(`${apiUrl}/summaryupload`, data, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
  },
  async getDocumentTypes() {
    return await api.get(`${apiUrl}/summarycertification/documenttypes/`);
  },
  async gettherapyDocumentTypes() {
    return await api.get(`${apiUrl}/therapyDocumentTypes/`);
  },
  async getCompanies(params) {
    return await api.get(
      `${apiUrl}/companies/${params.academicYearId}/${params.month}`
    );
  },
  async getSpecialistsByYearId(params) {
    return await api.get(
      `${apiUrl}/specialists/${params.academicYearId}/${params.month}`
    );
  },
};
